import React from 'react';
import {
  SimpleTreeView,
  SimpleTreeViewApiRef,
  TreeItem,
} from '@mui/x-tree-view';
import { styled } from '@mui/material/styles';
import { useSelector } from 'react-redux';
import { RootState } from '../../../stores/store';
import { Box } from '@mui/material';
import { HEADER_HEIGHT } from '../../../_constants/styleConst';
import { GetAccountsInfo, CompanyKeyName } from '../../../services/apiTypes';

interface OrganizationTreeProps {
  showUpdateModal: (organizationKey: string) => void;
  treeRef: SimpleTreeViewApiRef;
  itemRefs: React.RefObject<{
    [key: string]: HTMLDivElement | null;
  }>;
}

const StyledTreeItem = styled(TreeItem)(() => ({
  '& .MuiTreeItem-content': {
    display: 'flex',
    alignItems: 'center',
  },
}));

/** 組織ツリー */
const OrganizationTree: React.FC<OrganizationTreeProps> = ({
  showUpdateModal,
  treeRef,
  itemRefs,
}) => {
  const { accountsInfoData } = useSelector(
    (state: RootState) => state.accountsInfo,
  );

  const root: CompanyKeyName = {
    companyKey: 'root',
    companyName: 'root',
  };

  const renderTree = (nodes: GetAccountsInfo, parentKey: string | null) => {
    const normalizedNodes = nodes.companyList.map((node) =>
      node.key === node.primaryAgency.companyKey ||
      !nodes.companyList.some(
        (node2) => node2.key === node.primaryAgency.companyKey,
      )
        ? { ...node, primaryAgency: root }
        : node,
    );
    return normalizedNodes
      .filter((node) => node.primaryAgency.companyKey === parentKey)
      .map((node) => (
        <StyledTreeItem
          key={node.key}
          itemId={node.key}
          label={
            <div
              ref={(el) => {
                itemRefs.current[node.key] = el;
              }}
              onClick={() => showUpdateModal(node.key)}
            >
              {node.name}
            </div>
          }
        >
          {renderTree(nodes, node.key)}
        </StyledTreeItem>
      ));
  };

  return (
    <Box
      sx={{
        border: 1,
        borderRadius: '5px',
      }}
    >
      <Box
        sx={{
          height: `calc(100dvh - ${HEADER_HEIGHT} - 5rem)`,
          overflowY: 'auto',
          my: 0.5,
        }}
      >
        <SimpleTreeView apiRef={treeRef}>
          {renderTree(accountsInfoData, 'root')}
        </SimpleTreeView>
      </Box>
    </Box>
  );
};

export default OrganizationTree;
